module.exports = {"menuItem":{"labels":{"title":"SAVE","save":"Save","saveBackToList":"and back to list","saveBackToAdd":"and add another","preparePreview":"Prepare previews","warning":"The page is not saved, keep it open","preview":"Preview links"}}}


//////////////////
// WEBPACK FOOTER
// ./components/Custom/MenuItem/admin-en.json
// module id = VR9G
// module chunks = 18